/**
 * @fileoverview Styles for the MenuItem component. Defines the appearance of menu items including
 * their hover states, icons, and active states.
 *
 * @example
 * // Usage in MenuItem component:
 * import styles from './MenuItem.module.scss'
 *
 * <div className={styles.item}>
 *   <Icon className={styles.icon} />
 *   <span className={styles.title}>Menu Item</span>
 * </div>
 */

.item {
    @apply p-3 rounded-lg mb-2 transition-all text-gray-600;
}

.item:not(.active):hover .icon,
.item:not(.active):hover .title {
    @apply text-gray-900;
}

.icon {
    @apply w-6 mr-4 transition-all stroke-gray-400 stroke-2;
}

.title {
    @apply font-medium text-sm;
}

.active {
    @apply item bg-indigo-50;

    .icon {
        @apply stroke-indigo-500 stroke-2;
    }

    .title {
        @apply text-gray-900;
    }
}
